// "What's new" announcements shown once per user (WhatsNewModal.vue).
// Newest first. `id` is what gets stored as "seen" — change it to show the
// popup again after an update. Feature icons are feather icon names.

export default [
  {
    id: 'calls-2026-10-29',
    date: 'October 2026',
    kicker: 'New',
    title: 'Call your colleagues, right inside XYLO',
    intro: 'Video calls and screen sharing now work for everyone, from any page.',
    features: [
      {
        icon: 'VideoIcon',
        title: 'Call anyone, from anywhere',
        text: 'Click the camera icon in the top bar: everyone who has XYLO open is one click away. Add more people to turn a call into a meeting.'
      },
      {
        icon: 'MonitorIcon',
        title: 'Show your screen',
        text: 'Share your screen to walk a colleague through a quotation, an invoice or a report. It fills the window, sharp and readable.'
      },
      {
        icon: 'RefreshCwIcon',
        title: 'Calls that survive a bad Wi-Fi',
        text: 'A dropped connection reconnects by itself. If you reload the page or leave by mistake, a “Rejoin” button brings you straight back.'
      },
      {
        icon: 'SettingsIcon',
        title: 'Test your microphone and camera',
        text: 'Check what your colleagues will see and hear before you call, pick your devices, and get notified when someone calls you.'
      }
    ],
    cta: { label: 'Test my mic & camera', action: 'deviceCheck' }
  }
]
